// extracted by mini-css-extract-plugin
export default {"profileListItem":"styles_profileListItem__zvN2i","dropzoneActive":"styles_dropzoneActive__Y0x3n","dropzone":"styles_dropzone__X2Vt+"};